/**
 * Timing bundle for one Aperture lab study.
 * CSS keyframe delays in that study's intro.css must match HALO_EXPAND_*.
 *
 * Winner promotion: copy the chosen study's motion into fusionAperture/motionSpec.js,
 * then delete this lab folder. See registry.js.
 */

const CENTER_SIZE = { xs: 160, sm: 184, md: 208 };

export function buildLabMotion(overrides) {
  const delayS = overrides.HALO_EXPAND_DELAY_S;
  const durationS = overrides.HALO_EXPAND_DURATION_S;
  const flightMs = overrides.HANDOFF_FLIGHT_MS;
  const easing = overrides.FLIGHT_EASING ?? 'cubic-bezier(0.22, 0.05, 0.12, 1)';
  const crossfadeMs = overrides.LAND_CROSSFADE_MS ?? 320;

  return {
    placement: 'center',
    brightenOnHandoff: false,
    wordmarkDelayMs: null,
    introSize: CENTER_SIZE,
    DISMISS_DELAY_MS: 500,
    REDUCED_MOTION_FADE_MS: 300,
    PAGE_BRIGHTEN_MS: 700,
    INTRO_GLOW_FILTER: 'drop-shadow(0 0 40px rgba(255, 255, 255, 0.35))',
    GLOW_TAPER_START: 0.8,
    HERO_APERTURE_SCALE: 0.8,
    INTRO_CORE_RADIUS: 118,
    FLIGHT_MARK_BLEND_START: 0.82,
    selectors: {
      root: '.aperture-lab',
      core: '.aperture-lab__core',
      halo: '.aperture-lab__halo',
    },
    haloClass: 'aperture-lab__halo',
    ...overrides,
    FLIGHT_EASING: easing,
    LAND_CROSSFADE_MS: crossfadeMs,
    HANDOFF_TOTAL_MS: flightMs,
    INTRO_BUILD_FALLBACK_MS: delayS * 1000 + durationS * 1000 + 80,
    FLIGHT_TIMING: {
      duration: flightMs,
      easing,
      fill: 'forwards',
    },
    GLOW_FADE_TIMING: {
      duration: flightMs,
      easing: 'ease-out',
      fill: 'forwards',
    },
  };
}

export function flightOptionsFor(motion) {
  return {
    flightTiming: motion.FLIGHT_TIMING,
    glowFadeTiming: motion.GLOW_FADE_TIMING,
    blendStart: motion.FLIGHT_MARK_BLEND_START,
    coreRadius: motion.INTRO_CORE_RADIUS,
    apertureScale: motion.HERO_APERTURE_SCALE,
    glowFilter: motion.INTRO_GLOW_FILTER,
    glowTaperStart: motion.GLOW_TAPER_START,
    rootSelector: motion.selectors.root,
    coreSelector: motion.selectors.core,
    haloSelector: motion.selectors.halo,
    cutToHero: motion.cutToHero === true,
  };
}
